import { render, staticRenderFns } from "./DrugStats.vue?vue&type=template&id=51321734&scoped=true"
import script from "./DrugStats.vue?vue&type=script&lang=js"
export * from "./DrugStats.vue?vue&type=script&lang=js"
import style0 from "./DrugStats.vue?vue&type=style&index=0&id=51321734&prod&scoped=true&lang=css"
import style1 from "./DrugStats.vue?vue&type=style&index=1&id=51321734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51321734",
  null
  
)

export default component.exports